import { render, staticRenderFns } from "./AddDepthChartModal.vue?vue&type=template&id=33c80e69&"
import script from "./AddDepthChartModal.vue?vue&type=script&lang=js&"
export * from "./AddDepthChartModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports